import VehiclesForm from './VehiclesForm'
import VehiclesFormContainer from './VehiclesFormContainer'
import TrailerFormContainer from './TrailerFormContainer'

const Vehicles = VehiclesFormContainer(VehiclesForm)
const TrailerForm = TrailerFormContainer(VehiclesForm)

export { Vehicles as VehiclesForm, TrailerForm }
